export default __webpack_public_path__ + "dd6d3ea97c6e1251c6266cb97d1d54df.png";